import { useQuery } from "@tanstack/react-query";

import { platformStatsQuery } from "./platformStatsQuery";

export interface UseYaasThresholdsResult {
    /** Published retail distribution period, expressed in days. */
    distributionDays: number | null;
    /** Retail-program effective min-balance threshold (USDv); null
     *  until loaded or when the backend has no retail policy. */
    minBalance: string | null;
    /** Retail-program effective min-yield-per-distribution threshold;
     *  null until loaded or when not configured. */
    minYieldPerDistribution: string | null;
}

/**
 * Protocol thresholds from GET /api/yaas/stats (retail program's
 * effective min-balance / min-distribution-threshold policies).
 * Reads the shared platformStatsQuery, so surfaces that only need
 * the thresholds (e.g. AppFootnote) don't pull in the wallet dashboard. Missing values remain null.
 */
export function useYaasThresholds(): UseYaasThresholdsResult {
    const statsQuery = useQuery(platformStatsQuery);

    return {
        distributionDays: statsQuery.data?.distributionDays ?? null,
        minBalance: statsQuery.data?.minBalance ?? null,
        minYieldPerDistribution: statsQuery.data?.minYieldPerDistribution ?? null
    };
}
